import { withPrefix } from 'gatsby'
import LinkComponent from '../LinkComponent/LinkComponent'
import './DatasetBreadcrumbs.scss'

interface IDatasetBreadcrumbsProps {
  name?: string
  categoryByCategorySlug?: {
    name: string
    url?: string
  }
  className?: string
}

const DatasetBreadcrumbs = (props: IDatasetBreadcrumbsProps) => {
  const { name, categoryByCategorySlug, className = '' } = props
  return (
    <ol
      className={`DatasetBreadcrumbs__breadcrumb ${className}`}
      data-testid="dataset-breadcrumbs"
    >
      <li>
        <LinkComponent href={withPrefix('/')} className="text-brand-blue-4">
          Quantum Datasets
        </LinkComponent>
      </li>
      {categoryByCategorySlug && (
        <li className="hidden md:flex">
          <span className="DatasetBreadcrumbs__breadcrumbSeparator">/</span>
          {categoryByCategorySlug.url ? (
            <LinkComponent
              href={withPrefix(categoryByCategorySlug.url)}
              className="text-brand-blue-4"
            >
              {categoryByCategorySlug.name}
            </LinkComponent>
          ) : (
            <>{categoryByCategorySlug.name}</>
          )}
        </li>
      )}
      {name && (
        <li>
          <span className="DatasetBreadcrumbs__breadcrumbSeparator">/</span>
          {name}
        </li>
      )}
    </ol>
  )
}

export default DatasetBreadcrumbs
